import React, {PropsWithChildren} from "react";
import { classNames } from "../../shared/Utils";

interface RadioButtonGroupComponentProps {
    label?: string;
    name: string;
    className?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    options: { label: string; value: string }[];
}

const RadioButtonGroupComponentComponent: React.FC<RadioButtonGroupComponentProps> = ({label, name, className, options, value, onChange }) => {
    return (
        <div>
            {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
            <div className={'flex gap-1'}>
                {options.map((option) => (
                    <div key={option.value}
                         className={classNames("flex items-center p-2 px-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm mr-4 mt-2", className)}>
                        <input
                            id={option.value}
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={value === option.value}
                            onChange={onChange}
                            className="h-3 w-3 mr-2 text-orange focus:ring-0"
                        />
                        <label htmlFor={option.value} className="text-sm">{option.label}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default RadioButtonGroupComponentComponent;
